<div class="mx-auto max-w-screen-2xl py-32 md:py-14 lg:px-32">
  <div class="mb-12">
    <span class="mat-display-2 mb-0 font-bold text-dark-green"
      >Station configurator</span
    >
  </div>

  <div
    class="mb-6 flex flex-col items-center justify-between gap-4 md:flex-row"
  >
    <div class="w-full md:w-[350px]">
      <app-custom-search-field
        [(ngModel)]="searchTerm"
        (ngModelChange)="applyFilter()"
        [placeholder]="'Keresés'"
        [ariaLabel]="'Keresés'"
        maxWidth="100%"
      ></app-custom-search-field>
    </div>
  </div>

  <mat-card class="mat-elevation-z0 relative rounded-2xl md:p-14">
    <div
      *ngIf="loading"
      class="absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-white bg-opacity-75"
    >
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div>
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z0 w-full"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Állomás neve</th>
          <td mat-cell *matCellDef="let element">
            <span
              class="inline-block max-w-[200px] truncate pr-2 md:max-w-[150px] xl:max-w-[285px]"
              [matTooltip]="element.nameHu"
              matTooltipPosition="above"
            >
              {{ element.nameHu }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
            Címe
          </th>
          <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
            <span
              class="inline-block max-w-[200px] truncate pr-2 md:max-w-[150px] xl:max-w-[285px]"
              [matTooltip]="element.city + ', ' + element.postalCode"
              matTooltipPosition="above"
            >
              {{ element.city }}, {{ element.postalCode }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="w-40">Státusz</th>
          <td mat-cell *matCellDef="let element" class="w-40">
            {{ mapStatusToDisplay(element.status) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="w-16 md:w-44"></th>
          <td mat-cell *matCellDef="let element" class="w-16 md:w-44">
            <button
              mat-button
              color="primary"
              (click)="openEditDialog(element)"
              class="rounded-xl py-1 px-4 text-base font-bold"
            >
              <mat-icon color="primary" class="material-icons-outlined"
                >edit</mat-icon
              >
              <span class="hidden md:inline-block">Módosítás</span>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div
        *ngIf="!loading && dataSource.data.length === 0"
        class="flex h-96 flex-col items-center justify-center"
      >
        <img
          alt="No results"
          src="../../../assets/figures/man-questioning.svg"
          class="mb-2 h-[88px]"
        />
        <p class="text-lg font-bold">Nincs találat</p>
        <p class="text-sm">
          {{
            searchTerm
              ? "Próbálj meg más keresési kifejezést."
              : "Nincs elérhető állomás."
          }}
        </p>
      </div>
    </div>
  </mat-card>

  <mat-paginator
    *ngIf="dataLength > 0"
    [length]="dataLength"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="pageIndex"
    (page)="onPagination($event)"
    class="mt-6 rounded-2xl"
  >
  </mat-paginator>
</div>
